import React, { useEffect, useState } from "react"
import styles from "./chatIntegration.module.css"
import Button from "../../components/Form/Button"
import Table from "../../components/Table"
import { useNavigate, useParams } from "react-router-dom"
import { MdChatBubbleOutline, MdOutlineWhatsapp } from "react-icons/md"
import { useAuth } from "../../contexts/authContext"
import { RiInstagramLine, RiMessengerLine, RiPlugLine } from "react-icons/ri"
import BackButton from "../../components/BackButton"

const ChatIntegration = () => {
    const [data, setData] = useState([])
    const { account_id } = useParams()
    const { account } = useAuth()
    const navigate = useNavigate()

    useEffect(() => {
        if (account) {
            getDataByTable()
        }
    }, [account])

    const headers = [
        "#",
        "Nome",
        "Descrição",
        "",
        "",
    ]

    const getDataByTable = () => {
        const data = []
        const platforms = account?.chat?.platforms || []
        if (platforms.includes("whatsapp_api")) {
            data.push(
                {
                    id: 1,
                    value: [
                        "WhatsApp API",
                        "Conecte sua conta do WhatsApp API ao Oktto Chat",
                        <MdOutlineWhatsapp className="icon-md" style={{ color: "#25d366" }} />,
                        <Button variant="primary">Configurar</Button>,
                    ],
                    path: `/${account_id}/integrations/chat/whatsapp-api`,
                }
            )
        }
        if (platforms.includes("whatsapp")) {
            data.push(
                {
                    id: 2,
                    value: [
                        "WhatsApp Lite",
                        "Conecte sua conta do WhatsApp ao Oktto Chat",
                        <MdOutlineWhatsapp className="icon-md" style={{ color: "#25d366" }} />,
                        <Button variant="primary">Configurar</Button>,
                    ],
                    path: `/${account_id}/integrations/chat/whatsapp`,
                }
            )
        }
        if (platforms.includes("messenger")) {
            data.push(
                {
                    id: 3,
                    value: [
                        "Messenger",
                        "Conecte sua caixa de entrada do Messenger ao Oktto Chat",
                        <RiMessengerLine className="icon-md" style={{ color: "#0084ff" }} />,
                        <Button variant="primary">Configurar</Button>,
                    ],
                    path: `/${account_id}/integrations/chat/messenger`,
                }
            )
        }
        if (platforms.includes("direct")) {
            data.push(
                {
                    id: 8,
                    value: [
                        "Instagram Direct",
                        "Conecte sua caixa de entrada do Instagram Direct ao Oktto Chat",
                        <RiInstagramLine className="icon-md" style={{ color: "#e4405f" }} />,
                        <Button variant="primary">Configurar</Button>,
                    ],
                    path: `/${account_id}/integrations/chat/instagram-direct`,
                }
            )
        }
        data.push(
            {
                id: 4,
                value: [
                    "ChatBots IA",
                    "Crie seus chatbots para utilizar no Oktto Chat",
                    <MdChatBubbleOutline className="icon-md" />,
                    <Button variant="primary">Configurar</Button>,
                ],
                path: `/${account_id}/integrations/chat/chatbots`,
            },
            {
                id: 5,
                value: [
                    "Agentes IA",
                    "Crie seus agentes de atendimento para utilizar no Oktto Chat",
                    <MdChatBubbleOutline className="icon-md" />,
                    <Button variant="primary">Configurar</Button>,
                ],
                path: `/${account_id}/integrations/chat/agent-builder`,
            }
        )
        if (platforms.includes("whatsapp_api")) {
            data.push(
                {
                    id: 6,
                    value: [
                        "Campanhas",
                        "Crie campanhas para o WhatsApp API",
                        <MdOutlineWhatsapp className="icon-md" />,
                        <Button variant="primary">Configurar</Button>,
                    ],
                    path: `/${account_id}/integrations/chat/outbound-campaign`,
                }
            )
        }
        data.push(
            {
                id: 7,
                value: [
                    "Zaia",
                    "Integre seus bots Zaia para utilizar no Oktto Chat",
                    <RiPlugLine className="icon-md" />,
                    <Button variant="primary">Configurar</Button>,
                ],
                path: `/${account_id}/integrations/chat/zaia`,
            }
        )
        setData(data)
    }

    const handleNavigateToPage = (id) => {
        data?.forEach(el => {
            if (el.id === id) {
                navigate(el.path)
            }
        })
    }

    return (
        <div className={styles.container}>
            <div className="page-back-row">
                <BackButton fallback={`/${account_id}/integrations`} />
            </div>
            <Table
                headers={headers}
                values={data}
                onClick={(id) => handleNavigateToPage(id)}
                messageNotRegisters="Nenhum registro encontrado"
                showIndex={true}
            />
        </div>
    )
}

export default ChatIntegration
